import { useState, useEffect } from "react";
import { useTheme } from "@material-ui/core/styles";
import { useLocation } from "react-router-dom";
import whitelabelService from "../services/whitelabelService";
import defaultLogoLight from "../assets/logo.png";
import defaultLogoDark from "../assets/logo-black.png";

const useDynamicLogo = () => {
  const theme = useTheme();
  const location = useLocation();
  const [logoSrc, setLogoSrc] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const isDarkMode = theme.palette.type === "dark";
  const isLoginPage =
    location.pathname === "/login" || location.pathname === "/signup";

  const loadLogo = async () => {
    setLoading(true);
    setError(false);

    try {
      if (!isLoginPage && theme.calculatedLogoLight && theme.calculatedLogoDark) {
        setLogoSrc(isDarkMode ? theme.calculatedLogoLight() : theme.calculatedLogoDark());
        return;
      }

      const logos = isLoginPage
        ? await whitelabelService.getPublicLogos()
        : await whitelabelService.getCurrentLogos();

      const selectedLogo = isDarkMode ? logos.light : logos.dark;

      if (
        !selectedLogo ||
        selectedLogo === "/logo.png" ||
        selectedLogo === "/logo-black.png"
      ) {
        setLogoSrc(isDarkMode ? defaultLogoLight : defaultLogoDark);
      } else {
        setLogoSrc(selectedLogo);
      }
    } catch (error) {
      console.error("Erro ao carregar logo:", error);
      setLogoSrc(isDarkMode ? defaultLogoLight : defaultLogoDark);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadLogo();

    const handleLogoUpdate = () => {
      whitelabelService.clearCache();
      loadLogo();
    };

    const handleStorageChange = (event) => {
      if (event.key === "logoUpdated") {
        whitelabelService.clearCache();
        loadLogo();
      }
    };

    let pollInterval;
    if (isLoginPage) {
      pollInterval = setInterval(() => {
        whitelabelService.clearCache();
        loadLogo();
      }, 5000);
    }

    window.addEventListener("logoUpdated", handleLogoUpdate);
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("logoUpdated", handleLogoUpdate);
      window.removeEventListener("storage", handleStorageChange);
      if (pollInterval) {
        clearInterval(pollInterval);
      }
    };
  }, [isDarkMode, isLoginPage, theme.appLogoLight, theme.appLogoDark]);

  return { logoSrc, loading, error };
};

export default useDynamicLogo;
